import { Toaster as SonnerToaster } from 'sonner'

// 使い方のルール: docs/develop/client_ui/components/feedback.md

//
// アプリ全体で1つだけ置くトースト（sonner）の置き場。実際の呼び出しは `@/lib/notify` を使う。
//
// トーストは「消える通知」なので、**操作結果の唯一の表示手段にはしない**。
// 一覧に残る件数・失敗理由は ResultBanner や結果パネル（DOM に残る要素）で示し、
// トーストは「操作が届いたこと」を即座に返すための補助として重ねる
// （docs/develop/client_ui/screens/states.md「自動テストで結果を確かめられるようにする」）。
//
export function Toaster() {
  return (
    <SonnerToaster
      // 画面下部の右端に出す。上部中央だと、一覧画面の「N件を選択中」アクションバーと
      // ResultBanner（同じ文言が DOM に残る表示）に重なって、操作ボタンを覆い隠してしまう
      // （2026/08/30 mutation へのトースト適用時に実機で確認）
      position="bottom-right"
      closeButton
      richColors
      duration={4500}
      visibleToasts={4}
      offset={24}
      mobileOffset={16}
      toastOptions={{
        classNames: {
          toast: 'font-sans shadow-lg',
          title: 'text-sm font-semibold',
          description: 'text-sm',
          actionButton: 'font-medium',
          cancelButton: 'font-medium',
          closeButton: 'border-border bg-background text-foreground hover:bg-muted',
        },
      }}
    />
  )
}
